import { FormEvent, useContext, useEffect, useRef } from "react";
import { BotResponseData } from "../types/MessageData";
import { ConversationContext } from "../contexts/ConversationContext";
import { backendProxy } from "../hooks/backendProxy";
import styled from "styled-components";

const TopicInfoContainer = styled.div`
    position: absolute;
    z-index: 999;
    width: 300px;
    background-color: #f9f9f9;
    color: #000;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    bottom: 50px;
    right: 0px;
    transition: opacity 0.3s;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    font-size: 12px; 
    line-height: 14px;
    @media (max-width: 768px) {width: 280px;}
    @media (max-width: 480px) {max-width: calc(100vw - 20px);}
    @media (max-width: 360px) {right: 10px; width: 260px;}
    &::after {
        content: "";
        position: absolute;
        bottom: -11px;
        right: 15px;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #000 transparent transparent transparent;
        @media (max-width: 360px) {display: none;}
    }
`

const TopicInfoDiv = styled.div`
    > div {
     margin-top: 10px;
     margin-bottom: 7px;
    }

    input[type="button"] {
        cursor: pointer;
        border-radius: 13px;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 5px 10px;
        border: 1px solid #CCE6D6;
        background: #CCE6D6;
        &:hover {
            border-color: #adc3b6;
        }
    }
`

type TopicFilterProps = {
    message: BotResponseData;
    onCancel: () => void;
};

export const TopicFilter = ({ message, onCancel }: TopicFilterProps) => {
    const { conversationState, messages, addUserMessage } = useContext(ConversationContext);
    const formRef = useRef<HTMLDivElement>(null);
    

    useEffect(() => {
        const handleOutsideClick = (e: any) => {
            if (formRef.current && !formRef.current.contains(e.target)) {
                onCancel();
            }
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    });
    
    const onSend = async (e: FormEvent<HTMLInputElement>) => {
        e.preventDefault();
        let lastUserMessage = '';
        for (let i = messages.length - 1; i >= 0; i--) {
            if (messages[i].messageId === message.messageId && i > 0) {
                lastUserMessage = messages[i - 1].content;
            }
        }
        const topic = e.currentTarget.value;
        await backendProxy.trackEvent('send-message', message.clientId, { lastUserMessage, topic });
        if (lastUserMessage && topic) {
            addUserMessage(lastUserMessage, topic);
        }
        return false;
    }

    return <>
        {
            message.completed &&
            <TopicInfoContainer ref={formRef}>
                <TopicInfoDiv>
                    {message.mainTopic &&
                        <>
                        { message.additionalRelevantTopics && message.additionalRelevantTopics.length === 1 && 
                            <div style={{fontWeight: 'bold'}}>Diese Antwort wurde mit Informationen aus dem Themenbereich <b>{message.mainTopic}</b> generiert.</div>
                        }
                        { message.additionalRelevantTopics && message.additionalRelevantTopics.length > 1 && 
                            <div style={{fontWeight: 'bold'}}>Diese Antwort wurde ohne Einschränkung nach Themenbereich generiert.</div>
                        }
                        </>
                    }
                    {message.additionalRelevantTopics && message.additionalRelevantTopics.length > 1 ?
                        <>
                            <div>Relevante Informationen wurden in folgenden Themenbereichen gefunden. Um die Suche einzuschränken, wählen Sie einen der Themenbereiche:</div>
                            <div>
                                {message.additionalRelevantTopics.map((additionalRelevantTopic, index, array) => {
                                    return (
                                        <input key={additionalRelevantTopic} disabled={conversationState !== 'idle'} onClick={onSend} type="button" value={additionalRelevantTopic} />
                                    )
                                })
                                }
                            </div>
                        </>
                        : 
                        <>
                            <div>In keinen anderen Themenbereichen wurden ähnlich relevante Inhalte gefunden.</div>
                        </>
                    }
                </TopicInfoDiv>
            </TopicInfoContainer>
        }
    </>
}